/* GENERATED FILE — DO NOT EDIT.
 *
 * The phone's set-table columns for a coach exercise before anything is logged, emitted from the rule the
 * player asks:  HybridTrainer/Services/LoadFieldPolicy.swift  (`previewColumns(trackingFields:)`)
 *
 * Regenerate:  KATA_EMIT_WEB_TOKENS=1 ./tools/engine-tests/run.sh
 * The harness gate `w72-3-the-exercise-builder` regenerates this in memory on every run and fails if it differs.
 *
 * Keyed by `coach_exercises.tracking_fields` in its stored ORDER, joined with `,` — the order is the point:
 * `weight,reps` draws KG before REPS on the phone. Every ordered choice of up to 3 fields is listed.
 */

export const PREVIEW_COLUMNS: Readonly<Record<string, readonly string[]>> = {
  "": ["SET", "REPS", "KG", "REST"],
  "reps": ["SET", "REPS", "REST"],
  "weight": ["SET", "KG", "REST"],
  "time": ["SET", "TIME", "REST"],
  "rounds": ["SET", "ROUNDS", "REST"],
  "distance_m": ["SET", "M", "REST"],
  "distance_km": ["SET", "KM", "REST"],
  "reps,weight": ["SET", "REPS", "KG", "REST"],
  "reps,time": ["SET", "REPS", "REST"],
  "reps,rounds": ["SET", "REPS", "ROUNDS", "REST"],
  "reps,distance_m": ["SET", "REPS", "M", "REST"],
  "reps,distance_km": ["SET", "REPS", "KM", "REST"],
  "weight,reps": ["SET", "KG", "REPS", "REST"],
  "weight,time": ["SET", "KG", "TIME", "REST"],
  "weight,rounds": ["SET", "KG", "ROUNDS", "REST"],
  "weight,distance_m": ["SET", "KG", "M", "REST"],
  "weight,distance_km": ["SET", "KG", "KM", "REST"],
  "time,reps": ["SET", "REPS", "REST"],
  "time,weight": ["SET", "TIME", "KG", "REST"],
  "time,rounds": ["SET", "TIME", "ROUNDS", "REST"],
  "time,distance_m": ["SET", "TIME", "M", "REST"],
  "time,distance_km": ["SET", "TIME", "KM", "REST"],
  "rounds,reps": ["SET", "ROUNDS", "REPS", "REST"],
  "rounds,weight": ["SET", "ROUNDS", "KG", "REST"],
  "rounds,time": ["SET", "ROUNDS", "TIME", "REST"],
  "rounds,distance_m": ["SET", "ROUNDS", "M", "REST"],
  "rounds,distance_km": ["SET", "ROUNDS", "KM", "REST"],
  "distance_m,reps": ["SET", "M", "REPS", "REST"],
  "distance_m,weight": ["SET", "M", "KG", "REST"],
  "distance_m,time": ["SET", "M", "TIME", "REST"],
  "distance_m,rounds": ["SET", "M", "ROUNDS", "REST"],
  "distance_m,distance_km": ["SET", "M", "REST"],
  "distance_km,reps": ["SET", "KM", "REPS", "REST"],
  "distance_km,weight": ["SET", "KM", "KG", "REST"],
  "distance_km,time": ["SET", "KM", "TIME", "REST"],
  "distance_km,rounds": ["SET", "KM", "ROUNDS", "REST"],
  "distance_km,distance_m": ["SET", "KM", "REST"],
  "reps,weight,time": ["SET", "REPS", "KG", "REST"],
  "reps,weight,rounds": ["SET", "REPS", "KG", "ROUNDS", "REST"],
  "reps,weight,distance_m": ["SET", "REPS", "KG", "M", "REST"],
  "reps,weight,distance_km": ["SET", "REPS", "KG", "KM", "REST"],
  "reps,time,weight": ["SET", "REPS", "KG", "REST"],
  "reps,time,rounds": ["SET", "REPS", "ROUNDS", "REST"],
  "reps,time,distance_m": ["SET", "REPS", "M", "REST"],
  "reps,time,distance_km": ["SET", "REPS", "KM", "REST"],
  "reps,rounds,weight": ["SET", "REPS", "ROUNDS", "KG", "REST"],
  "reps,rounds,time": ["SET", "REPS", "ROUNDS", "REST"],
  "reps,rounds,distance_m": ["SET", "REPS", "ROUNDS", "M", "REST"],
  "reps,rounds,distance_km": ["SET", "REPS", "ROUNDS", "KM", "REST"],
  "reps,distance_m,weight": ["SET", "REPS", "M", "KG", "REST"],
  "reps,distance_m,time": ["SET", "REPS", "M", "REST"],
  "reps,distance_m,rounds": ["SET", "REPS", "M", "ROUNDS", "REST"],
  "reps,distance_m,distance_km": ["SET", "REPS", "M", "REST"],
  "reps,distance_km,weight": ["SET", "REPS", "KM", "KG", "REST"],
  "reps,distance_km,time": ["SET", "REPS", "KM", "REST"],
  "reps,distance_km,rounds": ["SET", "REPS", "KM", "ROUNDS", "REST"],
  "reps,distance_km,distance_m": ["SET", "REPS", "KM", "REST"],
  "weight,reps,time": ["SET", "KG", "REPS", "REST"],
  "weight,reps,rounds": ["SET", "KG", "REPS", "ROUNDS", "REST"],
  "weight,reps,distance_m": ["SET", "KG", "REPS", "M", "REST"],
  "weight,reps,distance_km": ["SET", "KG", "REPS", "KM", "REST"],
  "weight,time,reps": ["SET", "KG", "REPS", "REST"],
  "weight,time,rounds": ["SET", "KG", "TIME", "ROUNDS", "REST"],
  "weight,time,distance_m": ["SET", "KG", "TIME", "M", "REST"],
  "weight,time,distance_km": ["SET", "KG", "TIME", "KM", "REST"],
  "weight,rounds,reps": ["SET", "KG", "ROUNDS", "REPS", "REST"],
  "weight,rounds,time": ["SET", "KG", "ROUNDS", "TIME", "REST"],
  "weight,rounds,distance_m": ["SET", "KG", "ROUNDS", "M", "REST"],
  "weight,rounds,distance_km": ["SET", "KG", "ROUNDS", "KM", "REST"],
  "weight,distance_m,reps": ["SET", "KG", "M", "REPS", "REST"],
  "weight,distance_m,time": ["SET", "KG", "M", "TIME", "REST"],
  "weight,distance_m,rounds": ["SET", "KG", "M", "ROUNDS", "REST"],
  "weight,distance_m,distance_km": ["SET", "KG", "M", "REST"],
  "weight,distance_km,reps": ["SET", "KG", "KM", "REPS", "REST"],
  "weight,distance_km,time": ["SET", "KG", "KM", "TIME", "REST"],
  "weight,distance_km,rounds": ["SET", "KG", "KM", "ROUNDS", "REST"],
  "weight,distance_km,distance_m": ["SET", "KG", "KM", "REST"],
  "time,reps,weight": ["SET", "REPS", "KG", "REST"],
  "time,reps,rounds": ["SET", "REPS", "ROUNDS", "REST"],
  "time,reps,distance_m": ["SET", "REPS", "M", "REST"],
  "time,reps,distance_km": ["SET", "REPS", "KM", "REST"],
  "time,weight,reps": ["SET", "KG", "REPS", "REST"],
  "time,weight,rounds": ["SET", "TIME", "KG", "ROUNDS", "REST"],
  "time,weight,distance_m": ["SET", "TIME", "KG", "M", "REST"],
  "time,weight,distance_km": ["SET", "TIME", "KG", "KM", "REST"],
  "time,rounds,reps": ["SET", "ROUNDS", "REPS", "REST"],
  "time,rounds,weight": ["SET", "TIME", "ROUNDS", "KG", "REST"],
  "time,rounds,distance_m": ["SET", "TIME", "ROUNDS", "M", "REST"],
  "time,rounds,distance_km": ["SET", "TIME", "ROUNDS", "KM", "REST"],
  "time,distance_m,reps": ["SET", "M", "REPS", "REST"],
  "time,distance_m,weight": ["SET", "TIME", "M", "KG", "REST"],
  "time,distance_m,rounds": ["SET", "TIME", "M", "ROUNDS", "REST"],
  "time,distance_m,distance_km": ["SET", "TIME", "M", "REST"],
  "time,distance_km,reps": ["SET", "KM", "REPS", "REST"],
  "time,distance_km,weight": ["SET", "TIME", "KM", "KG", "REST"],
  "time,distance_km,rounds": ["SET", "TIME", "KM", "ROUNDS", "REST"],
  "time,distance_km,distance_m": ["SET", "TIME", "KM", "REST"],
  "rounds,reps,weight": ["SET", "ROUNDS", "REPS", "KG", "REST"],
  "rounds,reps,time": ["SET", "ROUNDS", "REPS", "REST"],
  "rounds,reps,distance_m": ["SET", "ROUNDS", "REPS", "M", "REST"],
  "rounds,reps,distance_km": ["SET", "ROUNDS", "REPS", "KM", "REST"],
  "rounds,weight,reps": ["SET", "ROUNDS", "KG", "REPS", "REST"],
  "rounds,weight,time": ["SET", "ROUNDS", "KG", "TIME", "REST"],
  "rounds,weight,distance_m": ["SET", "ROUNDS", "KG", "M", "REST"],
  "rounds,weight,distance_km": ["SET", "ROUNDS", "KG", "KM", "REST"],
  "rounds,time,reps": ["SET", "ROUNDS", "REPS", "REST"],
  "rounds,time,weight": ["SET", "ROUNDS", "TIME", "KG", "REST"],
  "rounds,time,distance_m": ["SET", "ROUNDS", "TIME", "M", "REST"],
  "rounds,time,distance_km": ["SET", "ROUNDS", "TIME", "KM", "REST"],
  "rounds,distance_m,reps": ["SET", "ROUNDS", "M", "REPS", "REST"],
  "rounds,distance_m,weight": ["SET", "ROUNDS", "M", "KG", "REST"],
  "rounds,distance_m,time": ["SET", "ROUNDS", "M", "TIME", "REST"],
  "rounds,distance_m,distance_km": ["SET", "ROUNDS", "M", "REST"],
  "rounds,distance_km,reps": ["SET", "ROUNDS", "KM", "REPS", "REST"],
  "rounds,distance_km,weight": ["SET", "ROUNDS", "KM", "KG", "REST"],
  "rounds,distance_km,time": ["SET", "ROUNDS", "KM", "TIME", "REST"],
  "rounds,distance_km,distance_m": ["SET", "ROUNDS", "KM", "REST"],
  "distance_m,reps,weight": ["SET", "M", "REPS", "KG", "REST"],
  "distance_m,reps,time": ["SET", "M", "REPS", "REST"],
  "distance_m,reps,rounds": ["SET", "M", "REPS", "ROUNDS", "REST"],
  "distance_m,reps,distance_km": ["SET", "M", "REPS", "REST"],
  "distance_m,weight,reps": ["SET", "M", "KG", "REPS", "REST"],
  "distance_m,weight,time": ["SET", "M", "KG", "TIME", "REST"],
  "distance_m,weight,rounds": ["SET", "M", "KG", "ROUNDS", "REST"],
  "distance_m,weight,distance_km": ["SET", "M", "KG", "REST"],
  "distance_m,time,reps": ["SET", "M", "REPS", "REST"],
  "distance_m,time,weight": ["SET", "M", "TIME", "KG", "REST"],
  "distance_m,time,rounds": ["SET", "M", "TIME", "ROUNDS", "REST"],
  "distance_m,time,distance_km": ["SET", "M", "TIME", "REST"],
  "distance_m,rounds,reps": ["SET", "M", "ROUNDS", "REPS", "REST"],
  "distance_m,rounds,weight": ["SET", "M", "ROUNDS", "KG", "REST"],
  "distance_m,rounds,time": ["SET", "M", "ROUNDS", "TIME", "REST"],
  "distance_m,rounds,distance_km": ["SET", "M", "ROUNDS", "REST"],
  "distance_m,distance_km,reps": ["SET", "M", "REPS", "REST"],
  "distance_m,distance_km,weight": ["SET", "M", "KG", "REST"],
  "distance_m,distance_km,time": ["SET", "M", "TIME", "REST"],
  "distance_m,distance_km,rounds": ["SET", "M", "ROUNDS", "REST"],
  "distance_km,reps,weight": ["SET", "KM", "REPS", "KG", "REST"],
  "distance_km,reps,time": ["SET", "KM", "REPS", "REST"],
  "distance_km,reps,rounds": ["SET", "KM", "REPS", "ROUNDS", "REST"],
  "distance_km,reps,distance_m": ["SET", "KM", "REPS", "REST"],
  "distance_km,weight,reps": ["SET", "KM", "KG", "REPS", "REST"],
  "distance_km,weight,time": ["SET", "KM", "KG", "TIME", "REST"],
  "distance_km,weight,rounds": ["SET", "KM", "KG", "ROUNDS", "REST"],
  "distance_km,weight,distance_m": ["SET", "KM", "KG", "REST"],
  "distance_km,time,reps": ["SET", "KM", "REPS", "REST"],
  "distance_km,time,weight": ["SET", "KM", "TIME", "KG", "REST"],
  "distance_km,time,rounds": ["SET", "KM", "TIME", "ROUNDS", "REST"],
  "distance_km,time,distance_m": ["SET", "KM", "TIME", "REST"],
  "distance_km,rounds,reps": ["SET", "KM", "ROUNDS", "REPS", "REST"],
  "distance_km,rounds,weight": ["SET", "KM", "ROUNDS", "KG", "REST"],
  "distance_km,rounds,time": ["SET", "KM", "ROUNDS", "TIME", "REST"],
  "distance_km,rounds,distance_m": ["SET", "KM", "ROUNDS", "REST"],
  "distance_km,distance_m,reps": ["SET", "KM", "REPS", "REST"],
  "distance_km,distance_m,weight": ["SET", "KM", "KG", "REST"],
  "distance_km,distance_m,time": ["SET", "KM", "TIME", "REST"],
  "distance_km,distance_m,rounds": ["SET", "KM", "ROUNDS", "REST"],
};

/** The phone's columns for these tracking fields, in their stored order (the column caps them at 3). */
export function previewColumns(trackingFields: readonly string[]): readonly string[] {
  return PREVIEW_COLUMNS[trackingFields.slice(0, 3).join(",")] ?? PREVIEW_COLUMNS[""] ?? [];
}
